export class ExecuteModel {

    /**
     * Response status
     */
    success: boolean = false;

    /**
     * Response message
     */
    message: string = '';

    /**
     * Transaction digest
     */
    digest: string = '';

    /**
     * Transaction events
     */
    events: Array<any> = [];

    /**
     * Successful signing
     * 
     * @param digest
     * @param events
     */
    pass(digest: string, events: Array<any>) {
        this.success = true;
        this.message = '';
        this.digest = digest;
        this.events = events;
    }

    /**
     * Failed signing
     * 
     * @param message 
     */
    fail(message: string) {
        this.success = false;
        this.message = message;
    }
}